export const MOUNT_SELECTOR = '.vue-patient-profile-modal-mount'

export const PATIENT_PROFILE_API_PATH = '/api/rates/patient_profile/'

export const PATIENT_PROFILE_EVENTS = {
  showModal: 'patient-profile:show-modal',
}
